import React from "react";
import ListViewTable from "../../../../../shared/components/ListViewTable";
import { TopCustomerRow } from "./TopCustomerRow";

const TableColumns = [
    { text: "Top", icon: <></> },
    { text: "Tên khách hàng", icon: <></> },
    { text: "Tổng tiền đã mua", icon: <></> },
    { text: "Chiếm %", icon: <></> },
];

const TopCustomersTable = () => {
    return (
        <ListViewTable
            url="/dashboard/customers/top/5/"
            rowElement={TopCustomerRow}
            tableColumns={TableColumns}
            subTitleText="Top 5 khách hàng"
        />
    );
};

export default TopCustomersTable;
